import {
  Navigate,
  useLocation,
  useParams,
} from 'react-router-dom';
import { OVERVIEW_TAB, Pillars } from 'types/analytics';
import OverviewDailyView from 'progress/profile/overview/dailyView';
import OverviewRangeView from 'progress/profile/overview/rangeView';
import StrainRangeView from 'progress/profile/strain/rangeView';
import StrainDailyView from 'progress/profile/strain/dailyView';
import RecoveryRangeView from 'progress/profile/recovery/rangeView';
import RecoveryDailyView from 'progress/profile/recovery/dailyView';
import SleepRangeView from 'progress/profile/sleep/rangeView';
import SleepDailyView from 'progress/profile/sleep/dailyView';
import { useDateRange } from 'insights/hooks/useDateRange';

function PillarRangeSelect() {
  const { pillar } = useParams();
  const location = useLocation();
  const { numOfSelectedDays } = useDateRange();

  if (pillar === OVERVIEW_TAB) {
    if (numOfSelectedDays === 1) {
      return (
        <OverviewDailyView />
      );
    }
    return <OverviewRangeView />;
  }
  if (pillar === Pillars.STRAIN) {
    if (numOfSelectedDays === 1) {
      return (
        <StrainDailyView />
      );
    }
    return <StrainRangeView />;
  }
  if (pillar === Pillars.RECOVERY) {
    if (numOfSelectedDays === 1) {
      return (
        <RecoveryDailyView />
      );
    }
    return <RecoveryRangeView />;
  }
  if (pillar === Pillars.SLEEP) {
    if (numOfSelectedDays === 1) {
      return (
        <SleepDailyView />
      );
    }
    return <SleepRangeView />;
  }
  const redirect = location.pathname.split('/').slice(0, -1).concat('overview').join('/');
  return <Navigate to={redirect} replace />;
}

export default PillarRangeSelect;
